import React from 'react';
import { Table } from 'react-bootstrap';

const AttendanceRecordTotalFilterDataTable = ({ employeeData, grandTotals, isLastEmployee }) => {
  if (!employeeData) {
    return null;
  }

  return (
    <>
      <Table className="custom-data-table" bordered size="sm" style={{ fontWeight: 400 }}>
        <thead className="rdt_TableHeadRow" style={{ backgroundColor: '#EBEBEB', textTransform: 'uppercase' }}>
          <tr className="rdt_TableCol">
            <th className="text-center align-middle">Dias Consultados</th>
            <th className="text-center align-middle">Horas Trabajadas</th>
            <th className="text-center align-middle">Horas no Trabajadas</th>
            <th className="text-center align-middle">Atrasos</th>
            <th className="text-center align-middle">Salidas Anticipadas</th>
            <th className="text-center align-middle">Tiempo Extra</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-center align-middle">{employeeData.consulting_days}</td>
            <td className="text-center align-middle">{employeeData.total_hours_worked}</td>
            <td className="text-center align-middle">{employeeData.total_hours_non_worked}</td>
            <td className="text-center align-middle">{employeeData.total_minutes_late}</td>
            <td className="text-center align-middle">{employeeData.total_minutes_early_departure}</td>
            <td className="text-center align-middle">{employeeData.total_minutes_hours_extra}</td>
          </tr>
        </tbody>
        <tfoot>
          {isLastEmployee && grandTotals && (
            <tr style={{ backgroundColor: '#EBEBEB' }}>
              <td className="text-right align-middle">
                <strong>TOTALES:</strong>
              </td>
              <td className="text-center align-middle">
                <strong>{grandTotals.total_hours_worked}</strong>
              </td>
              <td className="text-center align-middle">
                <strong>{grandTotals.total_hours_non_worked}</strong>
              </td>
              <td className="text-center align-middle">
                <strong>{grandTotals.total_minutes_late}</strong>
              </td>
              <td className="text-center align-middle">
                <strong>{grandTotals.total_minutes_early_departure}</strong>
              </td>
              <td className="text-center align-middle">
                <strong>{grandTotals.total_minutes_hours_extra}</strong>
              </td>
            </tr>
          )}
        </tfoot>
      </Table>
    </>
  );
};

export default AttendanceRecordTotalFilterDataTable;
